'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactiveContainer = require('reactive-container');

var _Container = require('./Container');

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactiveContainer = (0, _reactiveContainer.makeReactiveContainer)()(_Container2.default);

ReactiveContainer.displayName = 'ReactiveContainer';
ReactiveContainer.modifiers = _Container.MODIFIER_CONFIG;

exports.default = ReactiveContainer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-components-reactive-grid/dist/ReactiveContainer.js
// module id = 1481
// module chunks = 2